<template>
  <div v-if="cardData">
    <div class="mdc-card mgb-24">
      <div class="mdc-card__primary-action pdb-16 pdr-20 position-relative min-h-200" :class="cardData.thumbnail ? 'pdt-16 pdl-16': 'pdt-20 pdl-20'" tabindex="0" @click="moveToCoureseDetail(cardData.id)" @keypress="moveToCoureseDetail(cardData.id)">
        <div class="d-flex"> 
          <div v-if="cardData.thumbnail"
               class=" position-relative micro-degree-card-mage mgr-20">
            <img v-if="cardData.thumbnail"
                 :src="cardData.thumbnail.resourceUri"
                 alt=""
                 class="b-radius4">
<!--            <div class="mdc-chip-set  position-absolute " role="grid">-->
<!--              <div class="mdc-chip h-28 t-line-h-initial" role="row">-->
<!--                &lt;!&ndash; <div class="mdc-chip__ripple"></div> &ndash;&gt;-->
<!--                <span role="gridcell">-->
<!--                  <span class="mdc-chip__primary-action" role="button" tabindex="0">-->
<!--                    <span class="mdc-chip__text t-body3 pdt-2 t-color-white">{{ cardData.goods.paymentPrice === 0 ? $t("30006") : cardData.goods.paymentPrice }}</span>-->
<!--                  </span>-->
<!--                </span>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div class="flex-grow-1 mgl-4">
            <div class="t-headline7 font-m t-line-2 t-line-h-29">
              {{ cardData.name }}
            </div>
            <div class="pdt-8 pdb-12 d-flex align-items-baseline">
              <div class="t-body6 t-color-headlineBlack font-r mgr-6 t-line-h-20">by</div>
              <div class="t-body6 t-color-headlineBlack font-r t-line-h-20">{{ cardData.teacher && cardData.teacher.name.fullName }}</div>
            </div>

            <div class="mdc-chip-set mgl--8 mgt--8" role="grid" v-if="cardData.tags.length > 0">
              <div v-for="(tag, index) in cardData.tags" :key="index">
                <div v-if="index < 2"
                     class="mdc-chip h-22 t-line-h-initial bg-contentBlueInactive"
                     role="row">
                  <span role="gridcell">
                    <span class="mdc-chip__primary-action" role="button" tabindex="0">
                      <span class="mdc-chip__text t-body4 pdt-2 t-color-contentBlue font-r">#{{ tag.name }}</span>
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <div  v-if="cardData.skillSet.length > 0">
              <div class="mdc-chip-set mgl--8 mgt--8" role="grid" >
                <div v-for="(skill, index) in cardData.skillSet" :key="index" class="mdc-chip h-22 t-line-h-initial bg-contentBlueInactive" role="row">
                  <span role="gridcell">
                    <span class="mdc-chip__primary-action" role="button" tabindex="0">
                      <span class="mdc-chip__text t-body4 pdt-2 t-color-contentBlue font-r">{{ skill }}</span>
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <div class="d-flex" :class="cardData.skillSet.length > 0 || cardData.tags.length > 0 ? 'mgt-8 ':''">
              <div v-if="this.cardData.runningTime > 0"
                   class="d-flex align-items-center mgr-8">
	              <!-- <img alt="" class="w-18 h-18 mgr-4" src="/images/clock_loader_80.svg"> -->
                <i class="material-icons mgr-6 t-color-bodyGrayA font-18">timelapse</i>
	              <div class="t-body3 t-color-bodyGrayA font-r l-spacing45 t-nowrap">
		              {{ this.cardData.runningTime | timeToI18nFormat }}
	              </div>
              </div>
              <div class="d-flex align-items-center mgr-8">
	              <i class="material-icons mgr-4 t-color-bodyGrayA font-18">insert_chart</i>
	              <div class="t-body3 t-color-bodyGrayA font-r l-spacing45 t-nowrap">{{ cardData.levels[0].text }}</div>
              </div>
              <div v-show="cardData.certificateIds && cardData.certificateIds.length > 0"
                  class="d-flex align-items-center mgr-18">
	              <i class="material-icons mgr-6 t-color-bodyGrayA font-18">school</i>
	              <div class="t-body3 t-color-bodyGrayA font-r l-spacing45 t-nowrap">{{ $t('30011') }}</div>
              </div>
            </div>

            <div class="d-flex align-items-baseline mgt-12 justify-content-between min-h-18">
              <div v-if="cardData.reviewCount > 0" class="d-flex align-items-center">
	              <div class="t-body3 t-color-headlineBlack font-b mgr-6">{{ cardData.reviewAvg.toFixed(1) }}</div>
	              <div class="d-flex">
	                <i v-for="i in 5" :key="i" :class="{'selected': i <= cardData.reviewAvg}" class="material-icons t-color-iconInactive mgr-1 star font-18">star</i>
	              </div>
	              <div class="t-body3 t-color-bodyGrayA font-r mgl-6"> ({{ cardData.reviewCount }}) </div>
	            </div>
            </div>

            <div v-if="cardData.goods.currency" :class="cardData.thumbnail ? '': 'mgt-17'" class="d-flex align-items-baseline justify-content-end list-price-area">
              <div v-show="isPriced" class="t-body3 t-color-headlineBlack t-line-h-22 mgr-4 font-r">{{ cardData.goods.currency.key || "USD" }}</div>
              <div class="t-headline10 t-color-headlineBlack t-line-h-22 font-b" v-html="setPrice"></div>
              <div v-show="isPriced && cardData.goods.paymentPrice < cardData.goods.price"
                   class="t-line-through-red t-color-bodyGrayB mgl-8 font-r">
	              {{ cardData.goods.price | digitWithComma }}
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="divider mgt--1"></div>
      <div class="pdt-8 pdb-8 pdl-16 pdr-16">
        <ApplyStatusBtn :degreeData="cardData" ref="applyStatusBtn" />
        <button v-if="cardData.syllabus.resourceUri" class="mdc-button t-color-secondaryBtnText mgr-8 pdl-12 pdr-12 t-transform-unset" tabindex="0" @click="downloadSyllabus(cardData.syllabus)"><div class="mdc-button__ripple"></div>
          <span class="mdc-button__label t-body2 font-r">
            {{ $t('30007') }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import {utilDateMixin} from "@/mixins/dateUtil";
import httpService from "@/api/httpService";
import {mapState} from "vuex";

export default {
  name: "ListItem",
  components: {
    ApplyStatusBtn: () => import("../components/ApplyStatusBtn.vue")
  },

  props: ['cardData'],

  mixins: [utilDateMixin],

  computed: {
    setPrice() {
      if(this.isPriced) {
        return this.$options.filters.digitWithComma(this.cardData.goods.paymentPrice);
      } else {
        return this.$t('30006');
      }
    },

    isPriced() {
      return !!this.cardData.goods.price;
    },

  },

  methods: {
    downloadSyllabus(attachment) {
      let fileName = attachment.id ? attachment.originalName : attachment.split("/").pop();
      let resourceUri = attachment.id ? attachment.resourceUri : attachment;
      httpService
          .fileDownload(resourceUri)
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            console.log("error occured");
          });
    },

    moveToCoureseDetail(id) {
      this.$router.push({
        name: 'MicroCourseView',
        params: {
          degreeId: id
        }
      });
    },

    enrollMicroDegree(data) {
        this.$refs.applyStatusBtn.enrollMicroDegree(data);
    }
  }
}
</script>

<style scoped>
.font-18{
  font-size: 18px;
}
.mgt--1{
  margin-top:-1px;
}
</style>
